import type { AccountRole } from '../api/apiSchemas';
import type { SelectOption } from '../components/ui';

/** Account roles (spec §7.4, open decision §25 owned by Product). */
export const ACCOUNT_ROLE_OPTIONS: SelectOption[] = [
  { value: 'student', label: 'Học sinh / Sinh viên' },
  { value: 'teacher', label: 'Giáo viên' },
  { value: 'parent', label: 'Phụ huynh' },
  { value: 'other', label: 'Khác' },
];

export function accountRoleLabel(role: AccountRole | null): string {
  return ACCOUNT_ROLE_OPTIONS.find((o) => o.value === role)?.label ?? '—';
}
